import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import {Injectable} from '@angular/core';
import {AuthService} from '../service';
import {Router} from '@angular/router';
import { AuthNewService } from '../service/auth-new.service';
import { fetchAuthSession } from 'aws-amplify/auth';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router,
                private authService: AuthNewService) {}

    async getAuth(req: HttpRequest<any>, next: HttpHandler) {
      const session = await fetchAuthSession();
      req = req.clone({headers: req.headers.append('Authorization', session.tokens.idToken?.toString())});
      return next.handle(req).toPromise();
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return from(this.getAuth(req, next));
//         this.authService.getAuthenticatedUser().getSession((err, session) => {
//             if (err) {
// //                 console.log('Error in getting Session forwarding to login page');
//                 return;
//             }
//             const credential = session.getIdToken().getJwtToken();
//             req = req.clone({headers: req.headers.append('Authorization', credential)});
//
//         });
//         return next.handle(req);
    }
}
